import firebase from 'firebase';
import { determineFileType } from '../../Assessments/+store/assessments/assessments.validation2';
import { getDynamicAssessmentModel, AssessmentTypes } from '../../Assessments/+store/assessments/assessments.types';
import { createAssessmentSet, saveAssessmentSet } from '../../Assessments/+store/assessments/assessments.db';
import { saveAssessment } from '../../Assessments/+store/assessments/assessments.storage';
import { onFileUpload } from '../../Assessments/+store/assessments/assessments.api';

// Override writes go through callables (not direct client RTDB writes): the
// override node feeds A-F scores and org-wide RTDB write rules would otherwise
// let any authenticated user edit it. The callables enforce
// isSuperAdmin && role === 'districtAdmin' and clear the score cache server-side.
const getEndpoint = firebase.functions().httpsCallable('getAcceleratedTesters');
const updateOverrideEndpoint = firebase.functions().httpsCallable('updateAcceleratedTesterOverride');
const updateOverridesBulkEndpoint = firebase.functions().httpsCallable('updateAcceleratedTesterOverridesBulk');

export const getAcceleratedTesters = async (snapshotYear) => {
  const result = await getEndpoint({ snapshotYear });
  return result && result.data;
};

export const updateAcceleratedTesterOverride = async (snapshotYear, firebaseId, override) => {
  const result = await updateOverrideEndpoint({ snapshotYear, firebaseId, override });
  return result && result.data;
};

export const updateAcceleratedTesterOverridesBulk = async (snapshotYear, updates) => {
  const result = await updateOverridesBulkEndpoint({ snapshotYear, updates });
  return result && result.data;
};

// Upload a TEA Accelerated Testers Final listing straight from the override page,
// reusing the exact Assessment Manager pipeline (create set -> save file to storage
// -> save set record -> trigger backend processing). We first confirm the dropped
// file is actually an Accelerated Testers listing so the focused uploader can give a
// clear error instead of silently ingesting a SAT/roster/other file dropped here.
export const uploadAcceleratedTestersFile = async (profile, file) => {
  const fileType = await determineFileType(file);
  const type = fileType && fileType.type;
  if (!type || String(type).indexOf(AssessmentTypes.AcceleratedTesters) !== 0) {
    const err = new Error(
      'That file was not recognized as a TEA Accelerated Testers listing. Upload the "Accelerated_Testers_Final_<year>_<district>.csv" export from TEAL.'
    );
    err.code = 'notAcceleratedTesters';
    throw err;
  }
  const fields = { name: getDynamicAssessmentModel(type).name };
  const assessmentSetObj = await createAssessmentSet(profile, file, type, fields);
  await saveAssessment(profile, assessmentSetObj, file, () => {});
  await saveAssessmentSet(assessmentSetObj, profile);
  const [[assessmentSetId, assessmentSet]] = Object.entries(assessmentSetObj);
  // Backend onFileUpload parses the file, matches to the roster, and writes the
  // acceleratedTesters node. Awaiting it means the node is ready before we refetch.
  await onFileUpload({ name: assessmentSet.file.storageKey, assessmentSetId });
  const fileYear = Number(String(type).slice(AssessmentTypes.AcceleratedTesters.length)) || null;
  return { assessmentSetId, fileYear, fileName: file.name };
};

export default 'acceleratedTesters.api.js';
